import { Grid, IconButton, Typography } from '@mui/material';
import { LeftArrowIcon } from '../../assets/icons/Icons';
import { FileTile, FilterTile } from './DataTiles';
import { dateConverter } from '../../Utils/Helpers';

const ITEM_FILTER = [
	'All',
	'Onboarding',
	'Initial Care Plan',
	'Optimized Care Plan',
];

function DocumentOverview({
	residentFiles,
	selectedItem,
	onFilterDataTile,
	goBack,
	onDownloadResidentFile,
}) {
	return (
		<Grid
			container
			sx={{
				marginLeft: '30px',
				marginTop: '16px',
				padding: '16px',
				backgroundColor: '#FFFFFF',
			}}>
			<Grid
				container
				alignItems={'center'}
				justifyContent={'space-between'}
				flexDirection={'row'}>
				<Grid
					display={'flex'}
					alignItems={'center'}
					flexDirection={'row'}>
					<IconButton disableRipple onClick={goBack}>
						<LeftArrowIcon />
					</IconButton>
					<Typography
						color={'#191919'}
						fontSize={'18px'}
						marginLeft={'5px'}
						fontWeight={'600'}>
						Uploaded Documents
					</Typography>
				</Grid>
				<Grid paddingY="10px" marginTop={'10px'}>
					{ITEM_FILTER.map((item, index) => {
						return (
							<FilterTile
								key={index}
								name={item}
								isSelected={item === selectedItem}
								onClick={() => onFilterDataTile(item)}
							/>
						);
					})}
				</Grid>
			</Grid>
			<Grid container marginTop={'10px'} paddingX={'10px'} rowGap={1}>
				{residentFiles.length > 0 ? (
					residentFiles.map((item, index) => {
						return (
							<FileTile
								key={index}
								name={item.key.split('_')[1]}
								addedDate={dateConverter(item.date)}
								onDownload={() =>
									onDownloadResidentFile(
										item.key,
										item.type,
										true,
									)
								}
								onView={() =>
									onDownloadResidentFile(item.key, item.type)
								}
							/>
						);
					})
				) : (
					<Grid
						container
						justifyContent={'center'}
						alignItems={'center'}
						marginTop={'50px'}>
						<Typography
							sx={{
								whiteSpace: 'normal',
								wordBreak: 'break-word',
								padding: '10px',
								fontSize: '16px',
								color: '#3D4A58',
							}}
							fontWeight={'500'}>
							No Files
						</Typography>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
}

export default DocumentOverview;
